import type { Session } from '@supabase/supabase-js';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.ninjacash.app';

export const PROTECTED_ACCOUNT_EMAILS = new Set([
  'nova223@gmail.com',
  'teslax707@gmail.com',
  'takashi.kyoto.music@gmail.com',
  'shoshinzen24@gmail.com',
  'mike4x4delta@gmail.com',
]);

export interface AppAccessResult {
  allowed: boolean;
  reason: string;
}

export function isProtectedAccount(email: string | null | undefined): boolean {
  return PROTECTED_ACCOUNT_EMAILS.has((email || '').trim().toLowerCase());
}

export async function checkAppAccess(session: Session): Promise<AppAccessResult> {
  if (isProtectedAccount(session.user.email)) {
    return { allowed: true, reason: 'protected_account' };
  }

  try {
    const response = await fetch(`${API_BASE_URL}/api/access/status`, {
      headers: { Authorization: `Bearer ${session.access_token}` },
      signal: AbortSignal.timeout(8_000),
    });
    const body = await response.json().catch(() => ({})) as { allowed?: unknown; reason?: unknown };
    return {
      allowed: response.ok && body.allowed === true,
      reason: typeof body.reason === 'string' ? body.reason : `http_${response.status}`,
    };
  } catch (error) {
    console.warn('[ACCESS] Access check unavailable; non-protected account denied:', error);
    return { allowed: false, reason: 'access_check_unavailable' };
  }
}
